import axios from 'axios';

import { BASE_API_URL, processAPIWithHeadersForPractitioners } from '@/utils/helpers.js';

export const getXundAuthCode = async () => {
    try {
        const response = await processAPIWithHeadersForPractitioners('public/users/availability/xund/authorize', 'GET');

        return response;
    } catch (error) {
        console.debug('Error fetching Xund auth code:', error);
        throw error;
    }
};

export const pollXundResults = async (state) => {
    try {
        const response = await processAPIWithHeadersForPractitioners(
            `public/users/availability/xund/poll?state=${state}`,
            'GET'
        );

        return response;
    } catch (error) {
        console.debug('Error polling Xund results:', error);
        throw error;
    }
};

export const processXundRegisteredPdf = async (
    userSession,
    user_id,
    check_id,
    appointment_id,
    language,
    linked_form_code,
    location_id
) => {
    try {
        const token = userSession.idToken.jwtToken;
        const response = await axios.post(
            `${BASE_API_URL}/secure/user/form-data/xund/process-registered-pdf`,
            {
                user_id,
                check_id,
                appointment_id,
                language,
                linked_form_code,
                location_id,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
            }
        );
        return response ?? true;
    } catch (error) {
        console.debug('Error polling Xund results:', error);
        return false;
    }
};

export const processXundUnregisteredPdf = async (check_id, appointment_id, language, linked_form_code, location_id) => {
    try {
        const response = await axios.post(
            `${BASE_API_URL}/public/user/form-data/xund/process-unregistered-pdf`,
            {
                check_id,
                appointment_id,
                language,
                linked_form_code,
                location_id,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response ?? true;
    } catch (error) {
        console.debug('Error polling Xund results:', error);
        return false;
    }
};

export const isXundEnabled = (locationKey, customerId) => {
    console.debug('isXundEnabled', { locationKey, customerId });
    // return customerId === '294d6207-8d2d-447a-a2b3-54cb15af294c' || locationKey === 'hamburg-123';
    return false;
};
